import React from "react"
import "./botonesaccion.css"
import {convertStrToJson, doDownload} from "../../Global";

const BotonesAccion = (props) => {
    let data = props.rowsel;
    const tipoDoc = data.Tipo === "NC" ? "07" : "06";
    const oldXmlUrl = `${process.env.REACT_APP_FACT_BASE_URL}/datos/${data.Ruc}/xml/${tipoDoc}/${data.Ruc}-${tipoDoc}-${data.SerieCD}-${data.NumeroCE.replace(/^0+/g, '')}.xml`;
    const oldCdrUrl = `${process.env.REACT_APP_FACT_BASE_URL}/datos/${data.Ruc}/xml/${tipoDoc}/R-${data.Ruc}-${tipoDoc}-${data.SerieCD}-${data.NumeroCE.replace(/^0+/g, '')}.zip`;

    let resEnvioSunat = convertStrToJson(data.respuestaAnulacionSunat)
    let xml = resEnvioSunat.xmlFirmado && resEnvioSunat.xmlFirmado.length ? resEnvioSunat.xmlFirmado : oldXmlUrl;

    if (xml) {
        xml = xml.replace("http://", "https://")
    }

    let cdrZip = resEnvioSunat.cdrZip && resEnvioSunat.cdrZip.length ? resEnvioSunat.cdrZip : oldCdrUrl;

    if (cdrZip) {
        cdrZip = cdrZip.replace("http://", "https://")
    }

    const isAnulado = props.rowsel.Estado === 'ANULADA';

    return (
        <div className="dropdown drop-resp">
            <button className="btn options-ventas" type="button"
                    data-toggle="dropdown" aria-expanded="false">
            </button>
            <div className="dropdown-menu py-1">
                <div className="dropdown-item px-2">
                    <button
                        className="btn btn-primary btn-sm btn-block font-weight-bold"
                        title="enviar SUNAT"
                        onClick={() => props.onclickSendSUNAT(props.rowsel)}
                        disabled={props.rowsel.Estado !== 'PENDIENTE' || isAnulado}
                    >
                        Enviar SUNAT
                    </button>
                </div>

                {!(props.rowsel.Estado !== 'PENDIENTE' || isAnulado) && (
                    <div className="dropdown-item px-2">
                        <button
                            className="btn btn-warning btn-sm btn-block font-weight-bold"
                            onClick={e => { e.preventDefault(); props.history.push(`/note/${props.rowsel.idNc}`) }}
                            title="Editar"
                        >
                            Editar
                        </button>
                    </div>
                )}

                <div className="dropdown-item px-2">
                    <a
                        className={`btn btn-success btn-sm btn-block font-weight-bold ${isAnulado ? 'disabled' : ''}`}
                        title="descarga xml"
                        target="_blank"
                        href={xml}
                        onClick={e => {
                            if (isAnulado) {
                                e.preventDefault()
                                return
                            }
                            e.preventDefault()
                            doDownload(xml, `${data.Ruc}-${tipoDoc}-${data.SerieCD}-${data.NumeroCE.replace(/^0+/g, '')}.xml`)
                        }}
                    >
                        Descargar XML
                    </a>
                </div>

                <div className="dropdown-item px-2">
                    <a
                        className={`btn btn-success btn-sm btn-block font-weight-bold ${isAnulado ? 'disabled' : ''}`}
                        title="descarga cdr"
                        target="_blank"
                        href={cdrZip}
                        onClick={e => {
                            if (isAnulado) {
                                e.preventDefault()
                            }
                        }}
                    >
                        Descargar CDR
                    </a>
                </div>

                <div className="dropdown-item px-2">
                    <button
                        className="btn btn-danger btn-sm btn-block font-weight-bold"
                        title="descarga pdf"
                        onClick={() => props.downloadPDF(props.rowsel)}
                        disabled={isAnulado}
                    >
                        Descargar PDF
                    </button>
                </div>

                <div className="dropdown-item px-2">
                    <button
                        className="btn btn-info btn-sm btn-block font-weight-bold"
                        title="enviar correo electrónico"
                        onClick={() => props.enviarCorreo(props.rowsel)}
                        disabled={props.rowsel.Estado !== 'ACEPTADA' || isAnulado}
                    >
                        Enviar Correo
                    </button>
                </div>

                <div className="dropdown-item px-2">
                    <button
                        className="btn btn-danger btn-sm btn-block font-weight-bold"
                        title="anular nota"
                        onClick={() => props.anularNota(props.rowsel)}
                        disabled={isAnulado}
                    >
                        Anular Nota
                    </button>
                </div>

                <div className="dropdown-item px-2">
                    <button
                        className="btn btn-secondary btn-sm btn-block font-weight-bold"
                        title="consultar ticket"
                        onClick={() => props.consultaTicket(props.rowsel)}
                    >
                        Consultar Ticket
                    </button>
                </div>
            </div>
        </div>
    )
}

export default BotonesAccion
